import { animate } from "animejs";

class Module05Contact {
	constructor() {
		let cache = {};
		let initFunc = () => {
			initCache();
			registerEvents();
		};

		let initCache = () => {
			cache.wrappers = document.querySelectorAll(".words");
			cache.medias = document.querySelectorAll(".video-container .media");
			cache.CURRENT_CLASS = "current";
			cache.NEXT_CLASS = "next";
			cache.FADE_OUT_CLASS = "fade-out";
			cache.PRE_NEXT_CLASS = "pre-next";
			cache.isAnimating = false;
		};

		let registerEvents = () => {
			setupInitialState();
			rotatingClass();
		};

		// Configurer l'état initial pour tous les éléments
		const setupInitialState = () => {
			cache.wrappers.forEach((wrapper) => {
				const spans = wrapper.querySelectorAll("span");

				spans.forEach((span) => {
					if (span.classList.contains(cache.CURRENT_CLASS)) {
						span.style.opacity = "1";
						span.style.transform = "translateY(0)";
					} else if (span.classList.contains(cache.NEXT_CLASS)) {
						span.style.opacity = "0";
						span.style.transform = "translateY(100%)";
					} else {
						span.style.opacity = "0";
						span.style.transform = "translateY(100%)";
					}
				});

				// Jouer la première vidéo si c'est une vidéo
				if (cache.medias.length > 0) {
					const firstMedia = cache.medias[0];
					if (firstMedia.tagName === "VIDEO") {
						firstMedia.play().catch(() => {});
					}
				}
			});
		};

		const rotatingClass = () => {
			cache.wrappers.forEach((wrapper) => {
				setInterval(() => {
					if (cache.isAnimating) return;
					cache.isAnimating = true;

					const currentWord = wrapper.querySelector("span.current");
					const nextWord = wrapper.querySelector("span.next");

					if (!currentWord || !nextWord) {
						cache.isAnimating = false;
						return;
					}

					const nextNextWord = nextWord.nextElementSibling
						? nextWord.nextElementSibling
						: wrapper.firstElementChild;

					animate(currentWord, {
						opacity: [1, 0],
						translateY: [0, "-100%"],
						duration: 600,
						easing: "easeInOutCubic",
						complete: () => {
							currentWord.classList.remove(cache.CURRENT_CLASS);
							currentWord.classList.remove(cache.FADE_OUT_CLASS);
							
							currentWord.classList.add(cache.PRE_NEXT_CLASS);
							
							setTimeout(() => {
								currentWord.style.opacity = "0";
								currentWord.style.transform = "translateY(100%)";
								currentWord.classList.remove(cache.PRE_NEXT_CLASS);
							}, 1000);
						},
					});

					animate(nextWord, {
						opacity: [0, 1],
						translateY: ["100%", 0],
						duration: 600,
						easing: "easeOutCubic",
						begin: () => {
							nextWord.classList.remove(cache.NEXT_CLASS);
							nextWord.classList.add(cache.CURRENT_CLASS);
						},
						complete: () => {
							cache.isAnimating = false;
						},
					});

					if (nextNextWord && nextNextWord !== nextWord) {
						nextNextWord.classList.add(cache.NEXT_CLASS);
					}

					const mediaIndex = Array.from(wrapper.children).indexOf(nextWord);
					changeMedia(mediaIndex);
				}, 5000);
			});
			
			cache.wrappers.forEach((wrapper) => {
				const observer = new MutationObserver((mutations) => {
					mutations.forEach((mutation) => {
						if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
							const target = mutation.target;
							if (target.classList.contains(cache.NEXT_CLASS) && 
								!target.classList.contains(cache.CURRENT_CLASS) && 
								!target.classList.contains(cache.PRE_NEXT_CLASS)) {
								
								setTimeout(() => {
									target.style.opacity = "0";
									target.style.transform = "translateY(100%)";
								}, 1000);
							}
						}
					});
				});
				
				const spans = wrapper.querySelectorAll("span");
				spans.forEach((span) => {
					observer.observe(span, { attributes: true });
				});
			});
		};

		const changeMedia = (index) => {
			cache.medias.forEach((media, i) => {
				const isVideo = media.tagName === "VIDEO";

				if (i === index) {
					media.classList.add(cache.CURRENT_CLASS);
					media.classList.remove(cache.FADE_OUT_CLASS);
					if (isVideo) {
						media.muted = true;
						media.play().catch(() => {});
					}
					animate(media, {
						opacity: [0, 1],
						duration: 600,
						easing: "easeOutCubic",
					});
				} else {
					media.classList.add(cache.FADE_OUT_CLASS);
					media.classList.remove(cache.CURRENT_CLASS);
					animate(media, {
						opacity: [1, 0],
						duration: 400,
						easing: "easeInCubic",
						onComplete: () => {
							if (isVideo) {
								media.pause();
							}
						},
					});
				}
			});
		};

		initFunc();
	}
}

export { Module05Contact };